import { List, Map } from 'immutable';
import moment from 'moment';
import { createSelector } from 'reselect';

export const relayLoadContractSelector = state => state.entities.relayLoadContracts;

export const getRelayLoadContractsToRelayLoadMapping = createSelector(relayLoadContractSelector, contracts => {
  let myMap = Map();
  // let newLoads = loads.map( load => Map(load) );

  contracts.forEach(contract => {
    const relay_id = contract.get('relay_load', '0').toString();
    myMap = myMap.set(relay_id, myMap.get(relay_id, List()).push(contract));
  });

  return myMap.map(contractList =>
    contractList.sort((a, b) => (moment(a.get('contract_start')).isBefore(moment(b.get('contract_start'))) ? -1 : 1)),
  );
});
